const state = {
  konectVan: {
    state: 'home',
    item: {},
  }
}

const mutations = {
  setComponent(state, { component, item }) {
    state.konectVan = {
      state: component,
      item: item,
    }
  },
}

const actions = {
  setComponent({ commit }, data) {
    commit('setComponent', data)
  },
}

const getters = {
  konectVan: (state) => state.konectVan
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
